export default "__VITE_ASSET__BBpX0lwE__"